import * as React from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Stack,
  Avatar,
  MenuItem,
  Menu,
} from '@mui/material';
import {  colorPredictionTool, AvientLogo } from '../../asset/index';
import { useNavigate } from 'react-router-dom';
import {useStoreState, useStoreActions} from 'easy-peasy';
import { logout } from '../../utils';
 
export const TopNavBar = () => {
  const currentUser = useStoreState((state) => state.currentUser);
  const setCurrentUser = useStoreActions((actions) => actions.setCurrentUser);
  let {displayName  } = currentUser;
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  var avtarName = currentUser?.email? currentUser.email.split('@')[0]: 'NA';
  var avtarDisplayName = avtarName.split('.')
        .map((e) => e[0])
        .join('')
        .toUpperCase();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleSignOut = async () => {
    // logic for profile icon Sign out button
    try {
      setCurrentUser({displayName :  '' , email : ''})
      await logout();
      navigate('/login', { replace: true });
    } catch (err) {
      console.log('some error on logout');
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const navigatationToHome = () => {
    navigate('/home', { replace: true });
  };
  return (
    <>
      {' '}
      <AppBar
        position="fixed"
        sx={{
          marginBottom: '20px',
          top: '0px',
          backgroundColor: '#fff',
          zIndex: '99',
        }}
      >
        <Toolbar color={'#fff'}>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            flex="1"
            disableRipple
            onClick={navigatationToHome}
          >
            <img alt="instaColr logo" src={colorPredictionTool}  />
          </IconButton>
          <Stack direction="row" spacing={3} sx={{ marginLeft: 'auto' }}>
            <div>
              <Avatar
                sx={{
                  margin: '20px',
                  cursor: 'pointer',
                  color: '#303C43;',
                  fontSize: '20px',
                  fontWeight: '600',
                }}
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
              >
                {avtarDisplayName}
              </Avatar>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                {/* <MenuItem
                  sx={{
                    fontSize: '14px',
                    fontWeight: '600',
                    lineHeight: '28px',
                  }}
                >
                  { avtarDisplayName || 'NA'}
                </MenuItem> */}
                <MenuItem
                  sx={{
                    fontSize: '14px',
                    fontWeight: '400',
                    lineHeight: '24px',
                  }}
                >
                  {currentUser && currentUser.email}
                </MenuItem>
                <MenuItem
                  sx={{
                    fontSize: '14px',
                    fontWeight: '400',
                    lineHeight: '20px',
                    borderTop: '1px solid #CCCCCC',
                  }}
                  onClick={handleSignOut}
                >
                  Sign out
                </MenuItem>
              </Menu>
            </div>
            <IconButton size="large" edge="start" color="inherit" disableRipple>
              <img alt="Avient logo" src={AvientLogo} />
            </IconButton>
          </Stack>
        </Toolbar>
      </AppBar>
    </>
  );
};
